// extracted by mini-css-extract-plugin
export default {"root":"Label_root__0nfs5","hasChildren":"Label_hasChildren__YQrU2","text":"Label_text__Ntrcu","requiredMark":"Label_requiredMark__yVHtZ"};